import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { statesItems } from '../wikiutil';
import { InputBaseContainer, InputSelectWithLabel } from '../../../molecules';

const StatesDropdownModified = ({ control, setValue, watch, errors }) => {
  const defaultState = 'FL';
  const [stateValue, setStateValue] = useState<any>({ id: 'FL', name: 'Florida', title: 'Florida' });

  const val = watch('state');
  useEffect(() => {
    setValue('state', defaultState);
  }, []);

  useEffect(() => {
    if (val) {
        setValue('state', val);
        const _state = statesItems.find(si => si.id === val);
        setStateValue(_state);
    }
  }, [val]);

  const onChange = e => {
    setValue('state', e.id);
    const _state = statesItems.find(si => si.id === e.id);
    setStateValue(_state);
  };
  return (
    <InputBaseContainer>
      <Controller
        name="state"
        defaultValue={stateValue}
        control={control}
        render={props => (
          <InputSelectWithLabel
            name="state"
            selectAllActive
            placeholder=""
            menuPlacement="auto"
            isLoading={false}
            label="State"
            error={errors?.state}
            isDisabled={false}
            getOptionValue={(item: any) => item.id || Math.random()}
            getOptionLabel={(item: any) => item.name}
            isRequired
            options={statesItems}
            {...props}
            value={stateValue}
            onChange={onChange}
          />
        )}
      />
    </InputBaseContainer>
  );
};

export default StatesDropdownModified;

const Select = styled.select`
  width: 100%;
  height: 40px;
  margin-top: 8px;
  border-color: var(--defaultTableCellTitle);
  background-color: white;
`;
